import type { Events } from '~/event_bus';
import eventBus from '~/event_bus';

export type AnyEvent = Events['*'][0];
export interface ModalHistoryEntry { id: number; event: AnyEvent; onBack?: () => unknown }

export const useModalHistory = createGlobalState(() => {
    let nextId = 0;
    const history = ref<ModalHistoryEntry[]>([]);

    eventBus.on('*', (anyEvent) => {
        if (anyEvent.name.startsWith('modal')) {
            history.value.unshift({ id: nextId++, event: anyEvent });
        }
    });

    eventBus.on('close', (event) => {
        if (typeof event === 'string') {
            const index = history.value.findIndex((e) => e.event.name === event);
            if (index !== -1) {
                history.value.splice(index, 1);
            }
        } else {
            history.value.shift();
        }
    });

    eventBus.on('close.all', () => {
        history.value.length = 0;
    });

    return history;
});

export function onModalBack(handler: () => unknown) {
    const top = useModalHistory().value[0];
    if (top) top.onBack = handler;
}
